module.exports = __webpack_public_path__ + "img/plus.3fb324db.svg";